import script from "./WishSection.vue?vue&type=script&setup=true&lang=js"
export * from "./WishSection.vue?vue&type=script&setup=true&lang=js"

import "./WishSection.vue?vue&type=style&index=0&id=5db5e794&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5db5e794"]])

export default __exports__